<template>
  <div class="ai-helper">
    <div class="button" @click="open = !open">AI</div>
    <div :class="{open: open}" class="content-container">
      <textarea v-model="ai.in" class="in" :placeholder="placeholder"></textarea>
      <code-editor
        v-model="ai.out"
        cm-mode="vue"
        title="回复"
        style="height: 200px;"
        :line-wrapping="false"
      />
      <div class="button-row">
        <div class="button gray" @click="open = false">关闭</div>
        <div class="button" @click="startAi">开始</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiHelper',
  props: {
    roleDef: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请填写需求...'
    },
    param: {
      type: String,
      default: ''
    },
    dbInfo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ai: {
        in: undefined,
        out: undefined
      },
      open: false
    };
  },
  methods: {
    async startAi() {
      var loading = this.$loading({
        text: '正在生成...',
        mask: true,
      })
      var msg = `
// 系统变量
/**
 * 用户的网络请求，包含用户请求的所有数据，例如取用户请求参数的name，则写法为\${request.name}
 * 特殊变量值：
 * \${request.$url}: 用户此次请求的mapping
 * \${request.$ip}: 用户此次请求的来源IP地址
 * SQL语句中的专有的特殊变量：\${request.search}为带%%包裹的模糊查询变量，#{request.from}分页的起始，#{request.limit}分页的此次查询数量
 **/
var request;

/**
 * 用户的session，一般情况用户信息（同user表的数据）会存在session的user对象中，例如取用户ID则写法为\${session.user.id}
 **/
var session;

/**
 * 单次数据请求的结果存储容器，各个函数之间共享同一个result数据存储容器，也就是所有的数据改动、数据查询结果、数据计算结果均会存储在次容器中，若要访问result容器中的变量，直接使用对象访问方式进行访问即可，例如访问result容器中的user容器中的id，则这样编写\${result.user.id}，result会自动处理数据类型，如果通过表达式result.user.id取出来的是多个值，则会自动封装为Array类型，如果是单个值，则返回值的本身。注意所有的函数均会自动处理数组数据与单个数据（每个函数都会根据数据类型进行批处理），所以仅需关注函数本身逻辑即可。
 **/
var result = []

// 当前环境临时变量
var session.user; // 用户信息
      `;
      if (this.roleDef) {
        msg += '\n\n\n补充说明：'+ this.roleDef
      }
      if (this.dbInfo) {
        loading.setText('正在获取数据库表结构....')
        var db = this.$caches.openedProject.config.jdbcUrl.match(/\/[a-zA-Z_0-9]+\?/g)[0].substring(1)
        db = db.substring(0, db.length - 1)
        if (!window.cache_db_info) {
          window.cache_db_info = {}
        }
        const db_info = window.cache_db_info[db] ? window.cache_db_info[db] : (await this.getCurDBDesc())
        window.cache_db_info[db] = db_info
        msg += '\n\n\n数据库信息：\n' + db_info
      }
      if (this.param) {
        msg += '\n\n\n当前结果：\n' + this.param
      }
      msg += '\n\n\n用户要求：'+this.ai.in
      console.log(msg);
      loading.setText('正在等待来自的GPT回复....')
      const ai_resp = await this.$request('/ai/onceGpt', { msg })
      loading.close()
      this.ai.out = ai_resp.data.gpt_result
      this.$emit('aiResp', this.ai.out)
    },
    async getCurDBDesc() {
      var db = this.$caches.openedProject.config.jdbcUrl.match(/\/[a-zA-Z_0-9]+\?/g)[0].substring(1)
      db = db.substring(0, db.length - 1)

      const tables_resp = await this.$request('/dbms/tables', { db })
      const tables = tables_resp.data

      var db_desc = '';
      for (const row of tables) {
        const struct_resp = await this.$request('/dbms/struct', {table: `\`${db}\`.\`${row.TABLE_NAME}\``});
        const struct_data = struct_resp.data['Create Table']
        const struct = this.parseStruct(struct_data)

        db_desc += `${row.TABLE_NAME}(${row.TABLE_COMMENT}): `;
        for (const f of struct) {
          if (f.name == struct.PRIMARY_KEY) {
            db_desc += `${f.name}(${f.comment?f.comment:f.remark})(主键)、`
          } else if (f.name == struct.UNIQUE_KEY) {
            db_desc += `${f.name}(${f.comment?f.comment:f.remark})(唯一)、`
          } else {
            db_desc += `${f.name}(${f.comment?f.comment:f.remark})、`
          }
        }
        db_desc = db_desc.substring(0, db_desc.length - 1)
        db_desc += ';\n'
      }
      return db_desc;
    },
    indexOfArr(arrSource, arrTarget) {
      for (let i = 0; i <= arrSource.length - arrTarget.length; i++) {
        // 检查从当前位置开始的子数组是否与arrTarget相等
        let match = true;
        for (let j = 0; j < arrTarget.length; j++) {
          if (arrSource[i + j] !== arrTarget[j]) {
            match = false;
            break;
          }
        }
        // 如果找到匹配的子数组，返回其开始下标
        if (match) {
          return i;
        }
      }
      return -1;
    },
    parseStruct(data) {
      var tmpFields = data.split('\n')
      var fields = []
      console.log(data);
      for (var i = 1; i < tmpFields.length; i++) {
        const tmpField = tmpFields[i].endsWith(',') ? tmpFields[i].substring(0, tmpFields[i].length - 1) : tmpFields[i]
        var tmps = tmpField.match(/'[^']*'/g)
        var sp = tmpField.replace(/'[^']*'/g, '@#@').split(' ');
        // console.log(sp);
        var index = 0;
        for (let j = 0; j < sp.length; j++) {
          while(sp[j].includes('@#@')) {
            sp[j] = sp[j].replace('@#@', tmps[index++])
          }
        }
        var f = {
          comment: ''
        }
        var ind 
        if (sp[0] == ")") {
          continue
        }
        if ((ind = this.indexOfArr(sp, ['PRIMARY', 'KEY'])) != -1) {
          fields.PRIMARY_KEY = sp[4].match(/[a-zA-Z_]+/g)[0]
          continue
        }
        if ((ind = this.indexOfArr(sp, ['UNIQUE', 'KEY'])) != -1) {
          fields.UNIQUE_KEY = sp[5].match(/[a-zA-Z_]+/g)[0]
          continue
        }
        if ((ind = this.indexOfArr(sp, ['KEY'])) != -1) {
          fields.UNIQUE_KEY = sp[4].match(/[a-zA-Z_]+/g)[0]
          continue
        }
        if ((ind = this.indexOfArr(sp, ['CONSTRAINT'])) != -1) {
          fields.UNIQUE_KEY = sp[6].match(/[a-zA-Z_]+/g)[0]
          continue
        }
        if (sp[2].startsWith('`')) {
          // 字段
          f.name = sp[2].replace(/`/g, '')
          f.type = sp[3]
        }
        if ((ind = this.indexOfArr(sp, ['NOT', 'NULL'])) == -1) {
          f.isNull = true
        } else {
          f.isNull = false
        }
        if ((ind = this.indexOfArr(sp, ['AUTO_INCREMENT'])) != -1) {
          f.auto_increment = true
        }
        if ((ind = this.indexOfArr(sp, ['DEFAULT'])) != -1) {
          f.default = sp[ind + 1] ? sp[ind + 1].replace(/'|,/g, '') : ''
        }
        if ((ind = this.indexOfArr(sp, ['COMMENT'])) != -1) {
          f.comment = sp[ind + 1] ? sp[ind + 1].replace(/'/g, '') : ''
        }
        if ((ind = this.indexOfArr(sp, ['CHARACTER', 'SET'])) != -1) {
          f.charset = sp[ind + 2]
        }

        if (f.comment.replace(/\s/g, '').endsWith(',')) {
          f.comment = f.comment.substring(0, f.comment.lastIndexOf(','))
        }
        f.remark = f.comment ? f.comment : f.name

        // 数据类型到字段类型映射
        if (f.type.includes('varchar')) {
          f.input = 'text'
          f.dataType = 'string'
          f.min = 0
          f.max = parseInt(f.type.match(/[0-9]+/g)[0])
          if (f.max > 50) {
            f.input = 'textarea'
          }
        } else if (f.type.includes('enum')) {
          f.input = 'select'
          f.dataType = 'string'
          f.options = f.type.match(/'[^']*'/g)
          const comment = f.comment.replace(/\s/g, '').replace(/，/g, ',').replace(/（/g, '(').replace(/）/g, ')')
          const mapping = comment.match(/\([^)]+\)/g) ? comment.match(/\([^)]+\)/g)[0] : undefined
          const struct = {}
          let can_transform = false
          let can_not_transform = false
          if (mapping) {
            const mappings = mapping.substring(1, mapping.length - 1).split(',')
            for (const m of mappings) {
              const ms = m.split(':')
              if (ms.length >= 2) {
                struct[ms[0]] = ms[1]
              } else {
                can_not_transform = true
              }
            }
            if (mapping && f.options.length == mappings.length && !can_not_transform) {
              f.remark = comment.replace(/\([^)]+\)/g, '')
              can_transform = true
            }
          }
          for (var j = 0; j < f.options.length; j++) {
            f.options[j] = {
              name: can_transform ? struct[f.options[j].replace(/'/g, '')] : f.options[j].replace(/'/g, ''),
              value: f.options[j].replace(/'/g, '')
            }
          }
        } else if (f.type.includes('int')) {
          f.input = 'number'
          f.dataType = 'number'
          f.min = 0
          f.max = parseInt(f.type.match(/[0-9]+/g)[0])
          f.max = Math.pow(10, f.max) - 1
        } else if (f.type.includes('float')) {
          f.input = 'number'
          f.dataType = 'number'
          f.min = 0
          f.max = parseInt(f.type.match(/[0-9]+/g)[0])
          f.max = Math.pow(10, f.max) - 1
        } else if (f.type.includes('timestamp')) {
          f.input = 'time'
          f.dataType = 'date'
        } else if (f.type.includes('date')) {
          f.input = 'date'
          f.dataType = 'date'
        } else if (f.type.includes('text')) {
          f.input = 'textarea'
          f.dataType = 'string'
          f.min = 0
          if (f.type == 'tinytext') {
            f.max = 255
          } else {
            f.max = 65535
          }
        } else if (f.type.includes('blob')) {
          f.input = 'textarea'
          f.dataType = 'string'
          f.min = 0
          if (f.type == 'tinyblob') {
            f.max = 255 * 2
          } else {
            f.max = 65535 * 2
          }
        }
        fields.push(f)
      }
      console.log(fields)
      return fields
    },
  }
}
</script>
<style lang="scss" scoped>
.ai-helper {
  position: relative;
  display: inline-block;

  .button {
    background-color: #FA541C;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s ease;
    border-radius: 100px;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;

    &:hover {
      background-color: darken(#FA541C, 10%);
    }
  }

  .content-container {
    position: absolute;
    z-index: 9999;
    top: 0;
    left: 100%;
    margin-left: 10px; // Add some spacing between the button and the content
    min-width: 400px; // Fixed width for the content container
    max-width: 600px;
    background-color: #fff;
    border: 1px solid #ddd;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 10px;
    box-sizing: border-box;
    visibility: hidden; // Initially hidden
    opacity: 0; // Initially hidden
    transition: opacity 0.3s ease, visibility 0.3s ease;

    &.open {
      visibility: visible; // Make it visible when `open` class is applied
      opacity: 1;
    }
    .in {
      width: 100%;
      height: 100px;
      padding: 10px;
      border: 1px solid #ddd;
      border-radius: 4px;
      box-sizing: border-box;
      margin-bottom: 10px;
    }

    .button-row {
      display: flex;
      justify-content: flex-end;
      gap: 10px;

      .button {
        width: auto;
        margin-top: 10px;
        padding: 0 15px;
        font-weight: normal;
        &.gray {
          background-color: #a8a8a8;
          &:hover {
            background-color: darken(#d9d9d9, 10%);
          }
        }
      }
    }
  }
}
</style>